import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5a29c2db"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-column flex-root" }
const _hoisted_2 = { class: "d-flex flex-column flex-lg-row flex-column-fluid" }
const _hoisted_3 = { class: "d-flex flex-column flex-lg-row-fluid py-10 auth-content" }
const _hoisted_4 = { class: "language-select position-relative" }
const _hoisted_5 = { class: "d-flex flex-center flex-column flex-column-fluid" }
const _hoisted_6 = { class: "w-lg-700px p-10 p-lg-15 mx-auto" }
const _hoisted_7 = { class: "mb-10" }
const _hoisted_8 = { class: "welcome-text" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Massive Bio", -1))
const _hoisted_10 = { class: "sign-up-area" }
const _hoisted_11 = { class: "fv-row mb-7" }
const _hoisted_12 = { class: "form-label fw-bolder text-dark fs-6" }
const _hoisted_13 = { class: "fv-plugins-message-container" }
const _hoisted_14 = { class: "fv-help-block" }
const _hoisted_15 = {
  class: "mb-10 fv-row",
  "data-kt-password-meter": "true"
}
const _hoisted_16 = { class: "mb-1" }
const _hoisted_17 = { class: "form-label fw-bolder text-dark fs-6" }
const _hoisted_18 = { class: "position-relative mb-3" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/media/svg/files/show-password.svg",
  alt: ""
}, null, -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = { class: "fv-plugins-message-container" }
const _hoisted_22 = { class: "fv-help-block" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex align-items-center mb-3",
  "data-kt-password-meter-control": "highlight"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2" }),
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2" }),
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2" }),
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow-1 bg-secondary bg-active-success rounded h-5px" })
], -1))
const _hoisted_24 = { class: "text-muted" }
const _hoisted_25 = { class: "fv-row mb-5" }
const _hoisted_26 = { class: "form-label fw-bolder text-dark fs-6" }
const _hoisted_27 = { class: "position-relative mb-3" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/media/svg/files/show-password.svg",
  alt: ""
}, null, -1))
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = { class: "fv-plugins-message-container" }
const _hoisted_31 = { class: "fv-help-block" }
const _hoisted_32 = { class: "col-12 pt-2 mb-7 d-flex align-items-center" }
const _hoisted_33 = { class: "form-check form-check-dark pe-5" }
const _hoisted_34 = { class: "fv-plugins-message-container" }
const _hoisted_35 = { class: "fv-help-block" }
const _hoisted_36 = { class: "form-check form-check-dark pe-5" }
const _hoisted_37 = ["href"]
const _hoisted_38 = ["href"]
const _hoisted_39 = { class: "fv-plugins-message-container" }
const _hoisted_40 = { class: "fv-help-block" }
const _hoisted_41 = { class: "d-none" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "d-none",
  for: "form_language"
}, "form_language", -1))
const _hoisted_43 = ["value"]
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "d-none",
  for: "mbi_products"
}, "mbi_products", -1))
const _hoisted_45 = ["value"]
const _hoisted_46 = { class: "text-lg-end mt-10" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  type: "text",
  name: "referred_type",
  id: "referred_type",
  class: "d-none mobile_reset_mp",
  value: "Patient Platform"
}, null, -1))
const _hoisted_48 = { class: "indicator-label" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "Logo",
  src: "/media/svg/files/arrow-right.svg",
  class: "px-2"
}, null, -1))
const _hoisted_50 = { class: "indicator-progress" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  type: "text",
  name: "lead_type",
  class: "d-none",
  value: "Patient"
}, null, -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  type: "text",
  name: "referred_type",
  id: "referred_type",
  class: "d-none",
  value: "Patient Platform"
}, null, -1))
const _hoisted_54 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AuthAside = _resolveComponent("AuthAside")!
  const _component_language_select = _resolveComponent("language-select")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_AuthAside),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_language_select)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_Form, {
              class: "form w-100 fv-plugins-bootstrap5 fv-plugins-framework",
              novalidate: "novalidate",
              onSubmit: _ctx.onSubmitRegister,
              id: "kt_login_signup_form",
              "validation-schema": _ctx.registration
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("h1", _hoisted_8, [
                    _createTextVNode(_toDisplayString(_ctx.$t("Welcome to")) + " ", 1),
                    _hoisted_9
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createTextVNode(_toDisplayString(_ctx.$t("Already have an account?")) + " ", 1),
                    _createVNode(_component_router_link, {
                      to: "/sign-in",
                      class: "link-primary fw-bolder px-2"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("Sign in")), 1)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t("E-mail Address")), 1),
                  _createVNode(_component_Field, {
                    class: "form-control form-control-lg form-control-solid border-gray-300",
                    type: "email",
                    placeholder: _ctx.$t('E-mail Address'),
                    name: "email",
                    autocomplete: "off",
                    modelValue: _ctx.userEmail,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.userEmail) = $event))
                  }, null, 8, ["placeholder", "modelValue"]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(_component_ErrorMessage, { name: "email" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.$t("Password")), 1),
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(_component_Field, {
                        class: "form-control form-control-lg form-control-solid border-gray-300 password-input",
                        placeholder: _ctx.$t('Password'),
                        name: "password",
                        autocomplete: "off",
                        type: _ctx.password
                      }, null, 8, ["placeholder", "type"]),
                      _createElementVNode("a", {
                        class: "show-password-icon",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showPassword('password'))),
                        style: {"position":"absolute","right":"20px","top":"10px","width":"auto","border":"unset","background-color":"unset"}
                      }, _hoisted_20),
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          _createVNode(_component_ErrorMessage, { name: "password" })
                        ])
                      ])
                    ]),
                    _hoisted_23
                  ]),
                  _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.$t(
                      "Use 12 or more characters with a mix of letters, numbers & symbols."
                    )), 1)
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.$t("Confirm Password")), 1),
                  _createElementVNode("div", _hoisted_27, [
                    _createVNode(_component_Field, {
                      class: "form-control form-control-lg form-control-solid border-gray-300 password-input",
                      type: _ctx.password_confirmation,
                      placeholder: _ctx.$t('Confirm Password'),
                      name: "password_confirmation",
                      autocomplete: "off"
                    }, null, 8, ["type", "placeholder"]),
                    _createElementVNode("a", {
                      class: "show-password-icon",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showPassword('password_confirmation'))),
                      style: {"position":"absolute","right":"20px","top":"10px","width":"auto","border":"unset","background-color":"unset"}
                    }, _hoisted_29),
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, [
                        _createVNode(_component_ErrorMessage, { name: "password_confirmation" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("label", _hoisted_33, [
                    _createVNode(_component_Field, {
                      class: "form-check-input",
                      type: "checkbox",
                      name: "age_confirmation_checkbox",
                      value: true,
                      id: "age_confirmation_checkbox"
                    }),
                    _createVNode(_component_i18n_t, {
                      keypath: "AgeConfirmation",
                      class: "form-check-label text-gray-800 ps-2 fw-bold"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, [
                      _createVNode(_component_ErrorMessage, {
                        name: "age_confirmation_checkbox",
                        class: "fs-4 fs-sm-6"
                      })
                    ])
                  ])
                ]),
                _createElementVNode("label", _hoisted_36, [
                  _createVNode(_component_Field, {
                    class: "form-check-input",
                    type: "checkbox",
                    name: "signup_checkbox",
                    value: true,
                    id: "signup_checkbox"
                  }),
                  _createElementVNode("div", {
                    class: _normalizeClass(["flex-center fs-6 copyright", { 'ps-5 pe-5 font-8': _ctx.ismobile }])
                  }, [
                    _createVNode(_component_i18n_t, { keypath: "privacyPolicyTextSignUp" }, {
                      policy: _withCtx(() => [
                        _createElementVNode("a", {
                          href: _ctx.privacyPolicyUrl,
                          target: "_blank"
                        }, _toDisplayString(_ctx.$t("Privacy Policy")), 9, _hoisted_37)
                      ]),
                      terms: _withCtx(() => [
                        _createElementVNode("a", {
                          href: _ctx.termsAndConditionsUrl,
                          target: "_blank"
                        }, _toDisplayString(_ctx.$t("Terms & Conditions")), 9, _hoisted_38)
                      ]),
                      _: 1
                    })
                  ], 2)
                ]),
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("div", _hoisted_40, [
                    _createVNode(_component_ErrorMessage, {
                      name: "signup_checkbox",
                      class: "fs-4 fs-sm-6"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_41, [
                  _hoisted_42,
                  _createElementVNode("input", {
                    type: "text",
                    name: "form_language",
                    id: "form_language",
                    class: "d-none",
                    value: _ctx.currentLocale.toUpperCase()
                  }, null, 8, _hoisted_43),
                  _hoisted_44,
                  _createElementVNode("input", {
                    type: "text",
                    name: "mbi_products",
                    id: "mbi_products",
                    class: "d-none",
                    value: 
                    _ctx.currentLocale === 'en' ? 'CTMS' : 'CTMS - International'
                  
                  }, null, 8, _hoisted_45)
                ]),
                _createElementVNode("div", _hoisted_46, [
                  _hoisted_47,
                  _createElementVNode("button", {
                    id: "kt_sign_up_submit",
                    ref: "submitButton",
                    type: "submit",
                    class: _normalizeClass(["btn btn-lg btn-primary", { 'w-100': _ctx.ismobile }])
                  }, [
                    _createElementVNode("span", _hoisted_48, [
                      _createTextVNode(_toDisplayString(_ctx.$t("Sign Up")) + " ", 1),
                      _hoisted_49
                    ]),
                    _createElementVNode("span", _hoisted_50, [
                      _createTextVNode(_toDisplayString(_ctx.$t("Please wait")) + "... ", 1),
                      _hoisted_51
                    ])
                  ], 2),
                  _hoisted_52,
                  _hoisted_53,
                  _createElementVNode("input", {
                    type: "text",
                    name: "form_language",
                    class: "d-none",
                    value: _ctx.currentLocale.toUpperCase()
                  }, null, 8, _hoisted_54)
                ])
              ]),
              _: 1
            }, 8, ["onSubmit", "validation-schema"])
          ])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["d-flex flex-center flex-wrap fs-6 p-5 pb-0", {
            'd-flex flex-center fs-6 copyright': !_ctx.ismobile,
            'custom-mobile': _ctx.ismobile,
          }])
        }, null, 2)
      ])
    ])
  ]))
}